import ComplaintSimpleForm from './ComplaintAdvancedForm'

export default ComplaintSimpleForm
